import YoutubePlayer from 'youtube-player'

const ytOptions = {
    autoplay: true,
    modestBranding: true,
}

const parentSelector = '.f-text-video';
const playCssClass = 'play';

export default () => {

    const layouts = document.querySelectorAll(parentSelector);
    let players = [];

    layouts.forEach(l => {
        const playButton = l.querySelector(parentSelector + '__play-btn');

        if(playButton) {
            playButton.addEventListener('click', e => {

                const container = e.target.closest(parentSelector);
                const videoUrl = container.dataset.videoUrl;
                let videoId;

                if(videoUrl) {
                    videoId = get_youtube_video_id(videoUrl);
                }

                const playerTargetId = container.querySelector(parentSelector + '__player').id;

                if(document.querySelector('#' + playerTargetId)) {
                    let player = YoutubePlayer(playerTargetId, ytOptions);
                    player.loadVideoById(videoId);
                    players.push(player);
                    container.classList.toggle(playCssClass);
                }
            })
        }
    })
}

function get_youtube_video_id(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}